import React, {useCallback} from 'react';
import {useTheme} from '../../../../../../shared/theme';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {useNavigation} from '@react-navigation/native';
import {Screens} from '../../../../../../shared/routing';
import {SafeAreaView, TouchableOpacity, View} from 'react-native';
import {images} from '../../../../../../assets/icons';
import {Text} from '../../../../../../shared/components/text';
import Screen from '../../../../../../shared/components/screen';
import {EsiaRegCardFormScreen} from '..';
import {useDispatch, useSelector} from 'react-redux';
import {holderProfileSelector} from '../../../../../../redux/selectors/profile';
import {useIsSmallScreenDevice} from '../../../../../../shared/hooks/useIsSmallScreenDevice';
import {setRuntimeLoginStepState} from '../../../../../../redux/actions/runtime/loginStep';
import {LoginState} from '../../../../../../shared/models/login/loginStep';
import {useCustomBackhandler} from '../../../../../../shared/hooks/useCustomBackhandler';

export const EsiaRegCardFormMobile = () => {
  useCustomBackhandler();
  const theme = useTheme();
  const isSmallScreen = useIsSmallScreenDevice();
  const styles = useStyles(() => ({
    header: {
      ...theme.topBar.header,
      elevation: 6,
      minHeight: 54,
      paddingRight: 10,
      flexDirection: 'row',
      alignItems: 'center',
    },
    headerBackBtn: {
      width: 48,
      height: 48,
      alignItems: 'center',
      justifyContent: 'center',
    },
    headerTitle: {
      paddingRight: 24,
    },
    body: {
      flex: 1,
      paddingHorizontal: 16,
      paddingVertical: 20,
    },
  }));
  const profile = useSelector(holderProfileSelector());
  const isLogged = !profile;
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.navigate(Screens.Login);
    }
  }, [navigation]);
  const onSubmit = () => navigation.navigate(Screens.EsiaRegistrationCardMap);

  return (
    <Screen>
      <SafeAreaView>
        {isLogged ? (
          <View testID='header-container' style={styles.header}>
            <TouchableOpacity onPress={goBack} style={styles.headerBackBtn} testID='header-content'>
              <images.Left height={24} width={24} color={theme.color.primaryColor} />
            </TouchableOpacity>
            <Text type={isSmallScreen ? 'action' : 'h6'} style={styles.headerTitle}>
              Оформление нефинансовой ЕСК
            </Text>
          </View>
        ) : null}
      </SafeAreaView>
      <View style={styles.body}>
        <EsiaRegCardFormScreen onEsiaSubmit={onSubmit} />
      </View>
    </Screen>
  );
};
